function equalHeight() {
   var i = 0;
   var items = document.querySelectorAll(".equalheight .equal-boxes");
   var itemsHeight = [];
 
   if (items.length === 0) {
     return;
   }
   
   for (i = 0; i < items.length; i++) {
     
     itemsHeight.push(items[i].offsetHeight);
   }
   
   var maxHeight = Math.max(...itemsHeight);
   
   for (i = 0; i < items.length; i++) {
   
     items[i].style.height = maxHeight + "px";
   }
 }
export default equalHeight;



// WEBPACK FOOTER //
// ./src/js/partials/equal-height.js